import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Legal.css';

function Contact() {
  return (
    <>
      <Helmet>
        <title>İletişim | MEBS İpek Aksesuar</title>
        <meta name="description" content="MEBS İpek Aksesuar iletişim bilgileri. Sorularınız için bize ulaşın." />
      </Helmet>
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">İletişim</h1>
          <p className="legal-subtitle">Bize Ulaşın</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>E-posta ve Telefon</h2>
            <p>
              Her türlü soru ve talebiniz için bize aşağıdaki e-posta adresinden veya
              telefon numarası üzerinden ulaşabilirsiniz:
            </p>
            <p><strong>iletisim@mebssilk.com</strong></p>
            <p><strong>0532 233 67 76</strong></p>
          </section>

          <section className="legal-section">
            <h2>Adres</h2>
            <p>
              Küçükbakkalköy Mah. Alyakut Sok. Kardeşler Apt. <br />
              No:9 D:5 Ataşehir/İstanbul
            </p>
          </section>

          <section className="legal-section">
            <h2>Yanıt Süresi</h2>
            <p>
              E-posta ile iletilen talepleriniz en geç 1-2 iş günü içinde yanıtlanmaktadır.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default Contact;
